import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HelpDesk } from './helpdesk';
import { environment } from '../../../environments/environment';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class HelpdeskService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  Get(_helpDesk: HelpDesk): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/HelpDeskApi/GetByMenuId/', _helpDesk, { headers: header, observe: 'response' });
  }
}
